import http, { url } from '../../http'

const API_URL = "accident"

class accidentAPI {

  async save(accident) { 
    const response = await http(`${API_URL}/save`, 'POST', accident)
    return response
  }

  async getAllAccidentCompany(id,  page, search) {
    const response = await http(`${API_URL}/company/${id}?page=${page}&search=${search}` , 'POST')
    return response
  } 
  async getType() {
    const response = await http(`${API_URL}/type_accident/all`)
    return response
  } 

  async getTypeEvent() {
    const response = await http(`eventType`)
    return response
  } 
  async gettypeOfInjury() {
    const response = await http(`typeOfInjury`)
    return response
  } 
  async getAccidentAgent() {
    const response = await http(`accidentAgent`)
    return response
  } 
  async getInjuredPartBody() {
    const response = await http(`injuredPartBody`)
    return response
  } 

  async getAllAccidentPage(companiesID, page, search) {
    const response = await http(`${API_URL}/company/${companiesID}?page=${page}&search=${search}` , 'POST')
    return response || null
  }

  async getAllAccident(companiesID) {
    const response = await http(`${API_URL}/company/${companiesID}` , 'POST')
    return response || null
  }
 

  async getAccident(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }


  async updateAccident(id, accident) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', accident)
    return response
  }
 
  /** Item 3.2.2: adjunta (o quita) el FURAT de un reporte de accidente */
  async updateFurat(id, furatFile) {
    const response = await http(`${API_URL}/furat/${id}`, 'PUT', { furat_file: furatFile })
    return response
  }

  async deleteAccident(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async getAllAccidents(companiesID) {
    const response = await http(`${API_URL}/forcompany/${companiesID}`)
    return response || null
  }
  
  async delete(id) {
    const response = await http(`accident_investigation/delete/${id}`, 'DELETE')
    return response
  }

  /*rutas notAccidents*/
  async getAllNotAccidentPage(companiesID, page, search) {
    const response = await http(`notAccident/company/${companiesID}?page=${page}&search=${search}` , 'POST')
    return response
  }

  async notAccidents(companiesID){
    const response = await http(`notAccident/company/${companiesID}` , 'POST')
    return response
  }

  async saveNotAccident(accident) { 
    const response = await http(`notAccident/save`, 'POST', accident)
    return response
  }

  async deleteNotAccident(id) {
    const response = await http(`notAccident/delete/${id}`, 'DELETE')
    return response
  }
  
}

export default new accidentAPI()